module.exports = __webpack_public_path__ + "94a57b63ca8f95804870bde5b506ca61.woff";